<div class="notif-toast">
  <div class="notif-toast-accent"></div>

  <div class="notif-toast-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
  </div>

  <div class="notif-toast-body">
    <div class="notif-toast-title">{{ data.title }}</div>
    <div class="notif-toast-message" *ngIf="data.message">{{ data.message }}</div>
    <div class="notif-toast-link" *ngIf="data.redirectUrl" (click)="navigate()">
      View details →
    </div>
  </div>

  <button class="notif-toast-close" (click)="snackBarRef.dismiss()">&#x2715;</button>
</div>
